import React from 'react';

/** Renders one 1080 x 1350 slide. Used for the live preview and, at full size, for the downloads. */

const Arrow = () => (
  <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M8 24h32M28 12l12 12-12 12" />
  </svg>
);

const photoStyle = (photo) => ({ backgroundImage: `url("${photo}")` });
const LIGHT = { '--ink': '#fff8f0', '--accent': '#ffe3c9', '--muted': '#f1dccb', '--rule': 'rgba(255,255,255,.35)', color: '#fff8f0' };
const smallLabel = { fontFamily: 'var(--sb)', fontSize: 24, letterSpacing: '.16em', textTransform: 'uppercase', color: 'var(--accent)', display: 'block', marginBottom: 12 };

const Title = ({ text, emStyle }) => {
  const words = String(text || '').trim().split(/\s+/).filter(Boolean);
  if (!words.length) return null;
  const last = words.pop();
  return <>{words.length ? `${words.join(' ')} ` : ''}<em style={emStyle}>{last}</em></>;
};

const Head = ({ title, photo }) => (
  <div className="hd">
    <h2 className="h">{title}</h2>
    {photo && <div className="arch rel" style={photoStyle(photo)} />}
  </div>
);

const SlideView = ({ theme, slideId, index, vals, photo }) => {
  const v = (k) => vals[`${slideId}.${k}`] || '';
  const businessNo = theme === 'business'
    ? <div className="secno">Section {String(index + 1).padStart(2, '0')}</div>
    : <div className="rule" />;
  const pageNo = (style) => (
    <>
      <span className="pg" style={style}>{String(index + 1).padStart(2, '0')}</span>
      <span className="pgr" style={style}>The Wifey Application</span>
    </>
  );
  const cls = `sl t-${theme}`;

  if (slideId === 'cover') {
    if (photo) {
      return (
        <div className={cls} style={{ color: '#fff8f0', background: `linear-gradient(180deg,rgba(30,18,16,0) 52%,rgba(30,18,16,.8) 92%),url("${photo}") center/cover`, paddingBottom: 100 }}>
          <div style={{ marginTop: 'auto' }}>
            <div className="rule" style={{ background: '#fff8f0', marginBottom: 26 }} />
            <div className="big-title" style={{ fontSize: 88 }}><Title text={v('title')} emStyle={{ color: '#ffe3c9' }} /></div>
            <p className="wb-tag" style={{ maxWidth: 800, fontSize: 32, marginTop: 22 }}>{v('tagline')}</p>
          </div>
          <div className="swipe" style={{ color: '#ffe3c9', marginTop: 26, fontSize: 22 }}>Swipe to learn more <Arrow /></div>
          {pageNo({ color: '#ffe3c9' })}
        </div>
      );
    }
    return (
      <div className={cls}>
        <div style={{ marginTop: 180 }}>
          {theme === 'business' ? <div className="secno">Application</div> : <div className="rule" />}
          <div className="big-title"><Title text={v('title')} /></div>
          <p className="wb-tag">{v('tagline')}</p>
        </div>
        <div className="swipe">Swipe to learn more <Arrow /></div>
        {pageNo()}
      </div>
    );
  }

  if (slideId === 'about') {
    return (
      <div className={cls}>
        {businessNo}
        <Head title={`About ${vals['about.name'] ? vals['about.name'] : 'me'}`} photo={photo} />
        <dl className="kv">
          <div><dt>Age</dt><dd>{v('age')}</dd></div>
          <div><dt>Based in</dt><dd>{v('place')}</dd></div>
          <div><dt>Work</dt><dd>{v('work')}</dd></div>
        </dl>
        <p className="body" style={{ marginTop: 44 }}><b style={smallLabel}>Best known for</b>{v('known')}</p>
        {pageNo()}
      </div>
    );
  }

  if (slideId === 'seeking') {
    return (
      <div className={cls}>
        {businessNo}
        <Head title="Who I am seeking" photo={photo} />
        <dl className="kv">
          <div><dt>Age</dt><dd>{v('ageR')}</dd></div>
          <div><dt>Must love</dt><dd>{v('love')}</dd></div>
        </dl>
        <p className="body" style={{ marginTop: 44 }}><b style={smallLabel}>Preferences</b>{v('traits')}</p>
        {pageNo()}
      </div>
    );
  }

  if (slideId === 'deen' || slideId === 'why') {
    const title = slideId === 'deen' ? 'My deen' : 'Why I am doing this';
    const text = slideId === 'deen' ? v('deen') : v('why');
    const style = photo
      ? { ...LIGHT, background: `linear-gradient(180deg,rgba(30,18,16,.55) 0%,rgba(30,18,16,.72) 55%,rgba(30,18,16,.86) 100%),url("${photo}") center/cover` }
      : undefined;
    return (
      <div className={cls} style={style}>
        {businessNo}
        <h2 className="h" style={{ marginBottom: 56 }}>{title}</h2>
        <p className="pull">{text}</p>
        {pageNo()}
      </div>
    );
  }

  // apply
  return (
    <div className={cls}>
      {businessNo}
      <h2 className="h">How to apply</h2>
      <p className="body">If you are serious about marriage and think we may be a match, please fill out the application at the <b>{v('link')}</b>.</p>
      <span className="btn-like">Applications close {v('closes')}</span>
      {vals['apply.wali'] && <p className="wali">DMs will not receive a response. There is a formal process, and my wali reviews every application.</p>}
      <p className="small" style={{ marginTop: 46 }}>JazakAllahu khayran, and may Allah grant every one of us what is best for our dunya and akhirah.</p>
      {pageNo()}
    </div>
  );
};

export default SlideView;
